import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';
import { grey } from '@mui/material/colors';

const CustomRowText = styled(Typography)(({ theme }) => ({
  fontWeight: 700,
  paddingTop: theme.spacing(theme.spacingSizes.xxs),
  paddingBottom: theme.spacing(theme.spacingSizes.xxs),
}));

type Props = {
  key: string;
  label: string;
  period1: string;
  period2: string;
  period3: string;
};

export default function getCustomRow({
  key,
  label,
  period1,
  period2,
  period3,
}: Props) {
  return [
    getCustomRowCell(key, label),
    getCustomRowCell('period1', period1),
    getCustomRowCell('period2', period2),
    getCustomRowCell('period3', period3),
  ];
}

function getCustomRowCell(key: string, label: string) {
  return {
    key,
    content: <CustomRowText variant="h6">{label}</CustomRowText>,
    backgroundColor: grey[100],
  };
}
